export default "__VITE_ASSET__da93d0d6__"